<template>
  <footer class="footer">
    <p class="footer-text">
      Not So Good Stats | created by
      <span class="text-accent">Maciek Papciak</span>
    </p>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>
